import { render } from "./LessonCreate.vue?vue&type=template&id=4ffe7e94&scoped=true"
import script from "./LessonCreate.vue?vue&type=script&lang=js"
export * from "./LessonCreate.vue?vue&type=script&lang=js"

import "./LessonCreate.vue?vue&type=style&index=0&id=4ffe7e94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffe7e94"]])

export default __exports__